import {
  FestivalCompetitionEventsDateList,
  FestivalCompetitionEventsList,
  FestivalCompetitionEventsWrapper,
} from "./style";
import {
  FestivalSkeletonGrayBox,
  FestivalSkeletonWhiteBox,
} from "../../../../style/skeleton";

const RabbitFestivalCompetitionEventsSkeleton = () => {
  return (
    <FestivalCompetitionEventsWrapper>
      {Array.from({ length: 2 }, (_, index) => (
        <FestivalCompetitionEventsDateList key={index}>
          <FestivalSkeletonWhiteBox width="65px" height="24px" />
          <FestivalCompetitionEventsList>
            {Array.from({ length: 2 }, (item, i) => (
              <FestivalSkeletonGrayBox
                key={i}
                width="100%"
                height="230px"
                radius="8px"
              />
            ))}
          </FestivalCompetitionEventsList>
        </FestivalCompetitionEventsDateList>
      ))}
    </FestivalCompetitionEventsWrapper>
  );
};

export default RabbitFestivalCompetitionEventsSkeleton;
